export { default } from './TablePlaceholder';
export * from './TablePlaceholder';
